// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"f833a301","484":"2b28000c","940":"785e1ab9"}[chunkId] + ".chunk.js";
};